import React, { useEffect, useState } from "react";

import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { toast } from "react-toastify";

import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles((theme) => ({
  text: {
    whiteSpace: "pre-wrap",
    fontFamily: "inherit",
  },
  loadingBox: {
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(3),
  },
}));

/**
 * Modal do botão "Resumo": busca GET /carteira/apolice/:id/resumo só quando
 * abre (nunca pré-carrega para todas as apólices da lista) e mostra
 * `resumo_whatsapp`, já pronto pra copiar — nunca chama IA, é só leitura do
 * que já foi gerado na importação.
 */
const SummaryModal = ({ open, policyId, onClose }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    if (!open || !policyId) {
      setSummary(null);
      return;
    }
    setLoading(true);
    setSummary(null);
    (async () => {
      try {
        const { data } = await api.get(`/carteira/apolice/${policyId}/resumo`);
        setSummary(data);
      } catch (err) {
        toastError(err);
        onClose();
      } finally {
        setLoading(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, policyId]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(summary?.resumo_whatsapp || "");
      toast.success("Resumo copiado.");
    } catch (err) {
      toast.error("Não foi possível copiar.");
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Resumo da apólice</DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <div className={classes.loadingBox}>
            <CircularProgress size={28} />
          </div>
        ) : (
          <Typography variant="body2" className={classes.text}>
            {summary?.resumo_whatsapp || "Resumo não disponível."}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
        <Button
          onClick={handleCopy}
          color="primary"
          variant="contained"
          disabled={loading || !summary?.resumo_whatsapp}
          startIcon={<FileCopyOutlinedIcon />}
        >
          Copiar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SummaryModal;
